import BracketPointsInfoContainer from './BracketPointsInfoContainer';
export default BracketPointsInfoContainer;
